<script>
import { required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      notification_type: [
        { value: "E911", text: "E911" },
        { value: "Fax", text: "Fax" },
        { value: "WakeUp Call", text: "WakeUp Call" },
      ],
      company: {
        name: "",
      },
      emails: [""],
      sms: [""],
      voiceNumber: [""],
      submitted: false,
    };
  },
  props: {
    currentProps: Object,
  },
  emits: ["submitted"],
  validations: {
    company: {
      name: { required },
    },
  },
  methods: {
    onSubmit() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        console.log("Hello");
      }
    },

    // Method is used to add and remove template from emails
    handleEmail(action, index) {
      if (action == "add") {
        this.emails.push("");
      }
      if (action == "remove") {
        this.emails.splice(index, 1);
      }
    },

    // Method is used to add and remove template from sms
    handleSMS(action, index) {
      if (action == "add") {
        this.sms.push("");
      }
      if (action == "remove") {
        this.sms.splice(index, 1);
      }
    },

    // Method is used to add and remove template from voice number
    handleVoiceNumber(action, index) {
      if (action == "add") {
        this.voiceNumber.push("");
      }
      if (action == "remove") {
        this.voiceNumber.splice(index, 1);
      }
    },
  },
};
</script>

<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <h4>Add Notification Settings</h4>
        <hr />
      </div>
      <div class="col-md-12">
        <b-form>
          <div class="row">
            <div class="col-sm-6">
              <b-form-group class="mb-3" label-for="first_name">
                <span slot="label">
                  Type<span class="text-danger">*</span></span
                >
                <b-form-select
                  class="form-select"
                  id="company-type-input"
                  :options="notification_type"
                >
                </b-form-select>
              </b-form-group>
            </div>
            <div class="col-sm-6">
              <b-form-group class="mb-3" label-for="first_name">
                <span slot="label">
                  Phone Number<span class="text-danger">*</span></span
                >
                <b-form-input
                  id="first_name"
                  type="text"
                  autocomplete="off"
                  v-model="company.name"
                  :class="{
                    'is-invalid': submitted && $v.company.name.$error,
                  }"
                ></b-form-input>
                <div
                  v-if="submitted && $v.company.name.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.company.name.required"
                    >Company name is required.</span
                  >
                </div>
              </b-form-group>
            </div>
            <div class="col-sm-6">
              <div
                class="row align-items-center"
                v-for="(item, index) in emails"
                :key="index"
              >
                <div :class="index == 0 ? 'col-md-12' : 'col-11'">
                  <b-form-group class="mb-3" label-for="template">
                    <span slot="label"> Email ({{ index + 1 }})</span>
                    <b-form-input
                      id="template"
                      type="text"
                      autocomplete="off"
                      v-model="emails[index]"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-1" v-if="index !== 0">
                  <i
                    class="mdi mdi-trash-can fs-4 text-danger"
                    @click="handleEmail('remove', index)"
                  ></i>
                </div>
              </div>
              <div class="mb-3">
                <b-button
                  variant="primary"
                  id="add_row"
                  @click="handleEmail('add')"
                >
                  + Add Email
                </b-button>
              </div>
            </div>
            <div class="col-sm-6">
              <div
                class="row align-items-center"
                v-for="(item, index) in sms"
                :key="index"
              >
                <div :class="index == 0 ? 'col-md-12' : 'col-11'">
                  <b-form-group class="mb-3" label-for="template">
                    <span slot="label"> SMS ({{ index + 1 }})</span>
                    <b-form-input
                      id="template"
                      type="text"
                      autocomplete="off"
                      v-model="sms[index]"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-1" v-if="index !== 0">
                  <i
                    class="mdi mdi-trash-can fs-4 text-danger"
                    @click="handleSMS('remove', index)"
                  ></i>
                </div>
              </div>
              <div class="mb-3">
                <b-button
                  variant="primary"
                  id="add_row"
                  @click="handleSMS('add')"
                >
                  + Add SMS
                </b-button>
              </div>
            </div>
            <div class="col-sm-6">
              <div
                class="row align-items-center"
                v-for="(item, index) in voiceNumber"
                :key="index"
              >
                <div :class="index == 0 ? 'col-md-12' : 'col-11'">
                  <b-form-group class="mb-3" label-for="template">
                    <span slot="label"> SMS ({{ index + 1 }})</span>
                    <b-form-input
                      id="template"
                      type="text"
                      autocomplete="off"
                      v-model="voiceNumber[index]"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-1" v-if="index !== 0">
                  <i
                    class="mdi mdi-trash-can fs-4 text-danger"
                    @click="handleVoiceNumber('remove', index)"
                  ></i>
                </div>
              </div>
              <div class="mb-3">
                <b-button
                  variant="primary"
                  id="add_row"
                  @click="handleVoiceNumber('add')"
                >
                  + Add Voice No
                </b-button>
              </div>
            </div>
            <div class="col-sm-3 col-6">
              <label for="push_notification">Push Notification</label>
              <div class="form-check form-switch form-switch-md">
                <input class="form-check-input" type="checkbox" id="" />
              </div>
            </div>
            <div class="col-sm-3 col-6">
              <label for="status">Status</label>
              <div class="form-check form-switch form-switch-md">
                <input class="form-check-input" type="checkbox" id="" />
              </div>
            </div>
            <hr />
            <div class="col-md-12">
              <b-button
                class="float-end ms-2"
                variant="outline-primary"
                type="reset"
                >Cancel</b-button
              >
              <b-button
                class="float-end"
                variant="outline-primary"
                type="submit"
                @click.prevent="onSubmit"
              >
                <!-- <i
                  class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                  v-if="isBtnLoading"
                ></i> -->
                <!-- {{ this.isEdit ? "Update" : "Save" }} -->
                save
              </b-button>
            </div>
          </div>
        </b-form>
      </div>
    </div>
  </div>
</template>
